if (!customElements.get("main-slider")) {
  customElements.define(
    "main-slider",
    class MainSlider extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          swiper: this.querySelector(".main-slider__swiper")
        };
        function updateSlidesOpacity(swiper) {
          for (let i = 0; i < swiper.slides.length; i++) {
            const slide = swiper.slides[i];
            if (
              i >= swiper.activeIndex &&
              i < swiper.activeIndex + swiper.params.slidesPerView - 1
            ) {
              slide.classList.remove("swiper-slide-transparent");
            } else {
              slide.classList.add("swiper-slide-transparent");
            }
          }
        }
        const paginationEl = this.querySelector(".swiper-pagination");
        const swiper = new Swiper(this.elements.swiper, {
          // Optional parameters
          slidesPerView: 1.15,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          breakpoints: {
            768: {
              slidesPerView: 2.5,
              slidesPerGroup: 2,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            },
            1052: {
              slidesPerView: 3.5,
              slidesPerGroup: 3,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            }
          },

          pagination: {
            el: paginationEl ? paginationEl : undefined,
            clickable: true
          },
          on: {
            init: function () {
              updateSlidesOpacity(this);
            },
            slideChangeTransitionStart: function () {
              updateSlidesOpacity(this);
            },
            resize: function () {
              updateSlidesOpacity(this);
            }
          }
        });
      }
    }
  );
}
